import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthHelper } from '../helpers/auth.helper';
import { UserRole } from '@/app/auth/enums/role.enum';

export const adminGuard: CanActivateFn = (route, state) => {
  const authHelper = inject(AuthHelper);
  if (authHelper.isUserLogged()) {
    const userLogged = authHelper.getUserToken();
    if (userLogged?.user.role === UserRole.admin) return true;
  }
  inject(Router).navigateByUrl('/home');
  return false;
};
